// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@rc/XDL/types";
import { color } from "@rc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            css: css`
                letter-spacing: 0;
                margin-bottom: 5px;
                font-size: 14px;
                font-weight: 300;
                padding-bottom: 4px;
                line-height: 22px;
                -webkit-transition: color .2s ease-in,border-color .2s ease-in;
                transition: color .2s ease-in,border-color .2s ease-in;
                border-bottom: 1px solid transparent;
                display: flex;
                flex-wrap: wrap;
                &&&& {
                    color: ${color("common.ui5")};
                }
                .brand,
                .product-line {
                    display: flex;
                    sup {
                        padding: 0 3px;
                    }
                }

                &.current {
                    font-weight: 500;

                    &:active {
                        opacity: .75;
                    }
                }
            `,
        },
        css: css`
            flex-wrap: wrap;
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("common.ui10")};
            }

            ${StyledButton}:active > ${TypographyStyle} {
                opacity: .75;
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
